import React from "react";
import "./Progress.scss";
import { illustration, techStack } from "../../portfolio";
import { Fade } from "react-reveal";
import Build from "../../assets/lottie/build";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";

export default function StackProgress(isSoftSkills) {
  // const isSoftSkills = 
  if (techStack.viewSkillBars) {
    return (
      <Fade bottom duration={1000} distance="20px">
        <div className={isSoftSkills ? " skills-container softskills" : "skills-container"}>
          <div className="skills-bar">
            <h1 className="skills-heading">Professional Strengths</h1>
            {/* {techStack.experience.map((exp, i) => {
              const progressStyle = {
                width: exp.progressPercentage
              };
              return (
                <div key={i} className="skill">
                  <p>{exp.Stack}</p>
                  <div className="meter">
                    <span style={progressStyle}></span>
                  </div>
                </div>
              );
            })} */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "12px",
                marginTop: "20px",
              }}
            >
              {[
                "Problem Solving",
                "Communication",
                "Team Collaboration",
                "Quick Learning",
                "Adaptability",
                "Ownership",
              ].map((skill, index) => (
                <span
                  key={index}
                  style={{
                    padding: "10px 18px",
                    borderRadius: "25px",
                    background: "linear-gradient(135deg, #7b2ff7, #9b59b6)",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "500",
                    boxShadow: "0 4px 10px rgba(123, 47, 247, 0.3)",
                    cursor: "default",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "scale(1.05)";
                    e.target.style.boxShadow = "0 6px 15px rgba(123, 47, 247, 0.5)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "scale(1)";
                    e.target.style.boxShadow = "0 4px 10px rgba(123, 47, 247, 0.3)";
                  }}
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>

          <div className="skills-image">
            {illustration.animated ? (
              <DisplayLottie animationData={Build} />
            ) : (
              <img
                alt="Skills"
                src={require("../../assets/images/skill.svg")}
              />
            )}
          </div>
        </div>
      </Fade>
    );
  }
  return null;
}
